import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAdvancedSearch = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M4.5 7.5C4.22386 7.5 4 7.27614 4 7V3C4 2.72386 4.22386 2.5 4.5 2.5C4.77614 2.5 5 2.72386 5 3V7C5 7.27614 4.77614 7.5 4.5 7.5Z' />
    <path d='M4.5 21.5C4.22386 21.5 4 21.2762 4 21V12.812C4 12.5359 4.22386 12.312 4.5 12.312C4.77614 12.312 5 12.5359 5 12.812V21C5 21.2762 4.77614 21.5 4.5 21.5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 8.40002C6.32843 8.40002 7 9.0716 7 9.90002C7 10.7285 6.32843 11.4 5.5 11.4H3.5C2.67157 11.4 2 10.7285 2 9.90002C2 9.0716 2.67157 8.40002 3.5 8.40002H5.5ZM6 9.90002C6 9.62388 5.77614 9.40002 5.5 9.40002H3.5C3.22386 9.40002 3 9.62388 3 9.90002C3 10.1762 3.22386 10.4 3.5 10.4H5.5C5.77614 10.4 6 10.1762 6 9.90002Z'
    />
    <path d='M18.5 5.3C18.2239 5.3 18 5.07614 18 4.8V3C18 2.72386 18.2239 2.5 18.5 2.5C18.7761 2.5 19 2.72386 19 3V4.8C19 5.07614 18.7761 5.3 18.5 5.3Z' />
    <path d='M18.5 21.5C18.2239 21.5 18 21.2762 18 21V11.012C18 10.7359 18.2239 10.512 18.5 10.512C18.7761 10.512 19 10.7359 19 11.012V21C19 21.2762 18.7761 21.5 18.5 21.5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 7.90002C16 7.0716 16.6716 6.40002 17.5 6.40002H19.5C20.3284 6.40002 21 7.0716 21 7.90002C21 8.72845 20.3284 9.40002 19.5 9.40002H17.5C16.6716 9.40002 16 8.72845 16 7.90002ZM20 7.90002C20 7.62388 19.7761 7.40002 19.5 7.40002H17.5C17.2239 7.40002 17 7.62388 17 7.90002C17 8.17617 17.2239 8.40002 17.5 8.40002H19.5C19.7761 8.40002 20 8.17617 20 7.90002Z'
    />
    <path d='M11.5 21.5C11.2239 21.5 11 21.2762 11 21V17.012C11 16.7359 11.2239 16.512 11.5 16.512C11.7761 16.512 12 16.7359 12 17.012V21C12 21.2762 11.7761 21.5 11.5 21.5Z' />
    <path d='M11.5 11.7C11.2239 11.7 11 11.4761 11 11.2V3C11 2.72386 11.2239 2.5 11.5 2.5C11.7761 2.5 12 2.72386 12 3V11.2C12 11.4761 11.7761 11.7 11.5 11.7Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 14.112C9 13.2836 9.67157 12.612 10.5 12.612H12.5C13.3284 12.612 14 13.2836 14 14.112C14 14.9404 13.3284 15.612 12.5 15.612H10.5C9.67157 15.612 9 14.9404 9 14.112ZM13 14.112C13 13.8359 12.7761 13.612 12.5 13.612H10.5C10.2239 13.612 10 13.8359 10 14.112C10 14.3881 10.2239 14.612 10.5 14.612H12.5C12.7761 14.612 13 14.3881 13 14.112Z'
    />
  </svg>
);
export default SvgAdvancedSearch;
